<template>
  <div class=" is-fullwidth">

    <div class="is-pulled-right"></div>
    <div class="is-pulled-right"><input class="input" v-model="search" placeholder="search orders ..."/></div>
    <div class="is-pulled-right"><input class="input" type="date" v-model="start_date" /></div>
    <div class="buttons">
      
        <button class="button " v-bind:class="{'is-success': selected_location_id == row.id}" v-for="row in locations" :key="row.id" @click="selected_location_id = row.id">{{ row.name }}</button>
      
        <button class="button is-light">{{ filteredOrders.length }} orders</button>
        <button class="button is-light">{{ this.total_garments }} garments</button>
        <button
          class="button"
          :class="{ 'is-info': showArtworkOnly }"
          @click="showArtworkOnly = !showArtworkOnly"
        >
          Show Orders With Artwork Only
        </button>
    </div>
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
        <tr>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th @click="updateSortOrder('orderdate')" style="cursor:pointer;display:none">Order Date
            <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
            <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Garment</th>
          <th>Design</th>
          <th>Fabric</th>
          <th>Qty</th>
          <th>CAD ID</th>
          <th>&nbsp;</th>
          <th>Artwork</th>
          <th>Paper</th>
          <th>Rolls</th>
          <th>Gerber</th>
        </tr>
          
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="14" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="14" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
         <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
           <td style="display:none">{{order.orderdate}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.designname}}</td>
          <td>{{order.fabric_name}}</td>
          <td>{{ order.total_qty }}</td>
          <td>{{order.cad_id}}</td>
          <td><router-link :to="'/printing-cutting/bundling/' + order.orderID" v-if="order.print_location_id!=2">
                <span class="icon" :class="{ 'has-text-success': order.bundles_created == 1, 'has-text-danger': order.bundles_created == 0}">
                 <i class="fa fa-barcode">&nbsp;</i>
               </span>
               </router-link></td>
               <td>
                  <span class="tag is-success is-light" v-if="order.artwork_completed == 1">Completed</span>
                  <span class="tag is-warning is-light" v-else>Waiting</span>
               </td>
            <td>
            <span class="tag is-success is-light" v-if="order.artwork_printed_paper == 1">Completed</span>
            <span class="tag is-warning is-light" v-else-if="order.print_location_id==1">Strabane</span>
            <span class="tag is-warning is-light" v-else-if="order.print_location_id==2">Giurgiu</span>
            
          </td>
           <td>
            <span class="tag is-success is-light" v-if="order.artwork_printed_rolls == 1">Completed</span>
            <span class="tag is-warning is-light" v-else-if="order.fabric_print_location_id==1">Strabane</span>
            <span class="tag is-warning is-light" v-else-if="order.fabric_print_location_id==2">Giurgiu</span>
          </td>
           <td>
            <span class="tag is-success is-light" v-if="order.digital_print_cutting == 1">Completed</span>
            <span class="tag is-warning is-light" v-else-if="order.gerber_print_location_id==1">Strabane</span>
            <span class="tag is-warning is-light" v-else-if="order.gerber_print_location_id==2">Giurgiu</span>
          </td>
              
			</tr>
    	</tbody>
    </table>
    
    <button @click="exportXLS()" class="button is-info" v-if="loading==false">Export to Excel</button>
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      locations: [],
      selected_location_id: 0,
      order_by: 'deliverydate ASC',
      search: '',
      limit: '',
      accessToken: '',
      start_date: '',
      showArtworkOnly: false
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        this.orders = []
        
        OrderService.getPrintingPaperOrders(this.accessToken, this.selected_location_id, this.limit, this.order_by, this.start_date)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
    
    async processOrder(order) {
        this.working = true

        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             artwork_printed_paper: 1
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            order.artwork_printed_paper = 1
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async getLocations() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?printing=1&restrict_by_user=1").then(
               response => this.locations = response 
            );
      },
      exportXLS() {
      
      var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet 1"});
      XLSX.writeFile(wb, 'Printing Paper.xlsx')

    },
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(row) {
            if(  row.artwork_printed_paper == 0) // u.artwork_new == 0 && u.artwork_repeat == 0 &&
            {
              return 1
            }
          })

          if(this.showArtworkOnly) {
            filteredOrders = filteredOrders.filter(row => row.artwork_completed == 1)
          }

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     },
     total_garments: function () {
        return this.filteredOrders.reduce((total, order) => total + order.total_qty, 0);
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getLocations();
        });
  },
 
  mounted() {
    /*if (localStorage.printing_limit) {
      this.limit = localStorage.printing_limit;
    }
    else{
      this.limit = ''
    }*/

    if (localStorage.printing_location_id) {
      this.selected_location_id = localStorage.printing_location_id;
    }
    else{
      this.selected_location_id = 1
    }

    if (localStorage.printing_start_date) {
      this.start_date = localStorage.printing_start_date;
    }
    else{
      this.start_date = ''
    }
      
  },
  watch: {
    'selected_location_id'() {
      
      localStorage.printing_location_id = this.selected_location_id
      if(this.accessToken != '')
        {
      this.getOrders();
        }
    },
    'limit'() {
      localStorage.printing_limit = this.limit
      
      if(this.accessToken != '')
        {
      this.getOrders();
        }
    },
    'start_date'() {
      localStorage.printing_start_date = this.start_date
      
      if(this.accessToken != '')
        {
      this.getOrders();
        }
    }

  }
}


</script>

